module.exports = __webpack_public_path__ + "7ef73c13c29f35d0de4d41d410e00dc0.ttf";